import { BaseModel } from "@blue-chip/core";
import Contact from "./Contact";

export default class AddressBook extends BaseModel {
  static get hasMany() {
    return [Contact];
  }
}
